<template>
  <nav>
    <ul class="Gnav">
      <li class="concour alp"><a href="/concour/"><span>コンクール</span></a></li>
      <li class="teaching alp"><a href="/teaching/"><span>教材</span></a></li>
      <li class="event alp"><a href="/event/"><span>イベント</span></a></li>
    </ul>
  </nav>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
nav {
  max-width: 500px;
  width: 58%;
  .Gnav {
    @include flex();
    li {
      width: 31%;
      height: 100%;
    }
    a {
      display: block;
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
      text-align: center;
      span {
        display: inline-block;
        line-height: 80px;
      }
    }
    .concour span {
      background: url(../assets/img/common/menu_ico01.png) no-repeat left center;
      background-size: 44px auto;
      padding-left: 39%;
    }
    .teaching span {
      background: url(../assets/img/common/menu_ico02.png) no-repeat left center;
      background-size: 44px auto;
      padding-left: 39%;
    }
    .event span {
      background: url(../assets/img/common/menu_ico03.png) no-repeat left center;
      background-size: 26px auto;
      padding-left: 25.8%;
    }
  }
  @media only screen and (max-width: 1000px) {
    .Gnav a {
      font-size: 15px;
    }
  }
  @media only screen and (max-width: 750px) {
    width: 100%;
    .Gnav {
      display: block;
      li {
        width: 100%;
        text-align-last: left;
      }
      a {
        padding: 6vw 5.35vw;
        border-top: 1px solid #e5e5e5;
        text-align: left;
        span {
          width: 100%;
          padding-left: 16vw !important;
          font-size: 1.71rem;
          line-height: 1;
          padding: 20px 0;
        }
      }
      .concour span {
        background-size: 36px auto;
      }
      .teaching span {
        background-size: 38px auto;
      }
      .event span {
        background-size: 26px auto;
        background-position: 10px center;
      }
    }
  }
}
</style>

<script>
export default {
  name: "Gnav"
};
</script>
